// grade.js: blend the worlds' colour grades across cuts.
import { lerp } from './util.js';

// the same neutral base the world harness uses, so worlds look as tested
export const DEFAULT_GRADE = {
  exposure: 1, bloomK: 0.8, sat: 1.05, contrast: 1.04, vignette: 0.35, grain: 0.035, ca: 0, threshold: 0.9,
  highs: [0, 0, 0], shadows: [0.12, 0.18, 0.54], gainC: [1, 1, 1],
};
const KEYS = Object.keys(DEFAULT_GRADE);

export function makeGrade() {
  const g = {};
  for (const k of KEYS) g[k] = Array.isArray(DEFAULT_GRADE[k]) ? DEFAULT_GRADE[k].slice() : DEFAULT_GRADE[k];
  return g;
}

function val(g, k) {
  const v = g && g[k];
  if (v === undefined || v === null) return DEFAULT_GRADE[k];
  if (Array.isArray(DEFAULT_GRADE[k])) return Array.isArray(v) && v.length >= 3 && v.every(Number.isFinite) ? v : DEFAULT_GRADE[k];
  return Number.isFinite(v) ? v : DEFAULT_GRADE[k];
}

// out = mix(a, b, t) with every missing key taken from the default
export function mixGrade(out, a, b, t) {
  for (const k of KEYS) {
    const va = val(a, k), vb = val(b, k);
    if (Array.isArray(va)) { for (let i = 0; i < 3; i++) out[k][i] = lerp(va[i], vb[i], t); } else out[k] = lerp(va, vb, t);
  }
  return out;
}

// out += delta * w (delta holds only the keys it changes)
export function nudgeGrade(out, delta, w) {
  if (!delta || w <= 0) return out;
  for (const k in delta) {
    if (!(k in out)) continue;
    const d = delta[k];
    if (Array.isArray(out[k])) { for (let i = 0; i < 3; i++) out[k][i] += d[i] * w; } else out[k] += d * w;
  }
  return out;
}

// out = mix(out, target, w) for the keys in target
export function towardGrade(out, target, w) {
  if (!target || w <= 0) return out;
  for (const k in target) {
    if (!(k in out)) continue;
    if (Array.isArray(out[k])) { for (let i = 0; i < 3; i++) out[k][i] = lerp(out[k][i], target[k][i], w); } else out[k] = lerp(out[k], target[k], w);
  }
  return out;
}
